import $ from 'jquery';
import Cookies from 'js-cookie';
import validationRules from '../utils/validation';

const countdownEnd = $('#countdown-timer').data('countdown-end');
const createCookie = $('.js-newsletter-form').data('create-cookie');

class CountdownOverlay {
	constructor() {
	}

	init() {
		this.bindEvents();
		this.checkCurrentUrl();
		this.updateFormListeners();
	}

	checkCurrentUrl() {
		// Check if we should create a cookie or not
		if (createCookie) {
			const cookieName = $('.js-newsletter-form').data('cookie-name');
			const cookieDate = $('.js-newsletter-form').data('cookie-expire');
			// Check if cookie exists
			if (Cookies.get(cookieName) && Cookies.get(cookieName).length) {
				// show email already submitted
				$('#cta-submitted').removeClass('d-none');
			}
			else {
				// show email sign-up
				$('#countdown-cta').removeClass('d-none');
			}
		} else {
			$('#countdown-content').removeClass('d-none');
		}
	}

	updateFormListeners() {
		$('.js-newsletter-form form').submit((event) => {
			this.newsletterSignup(event.target, event);
		});
	}

	newsletterSignup(form, event) {
		// validate form data
		const email = $(form).find('input[name=cons_email]');
		const cookieName = $('.js-newsletter-form').data('cookie-name');
		const cookieDate = $('.js-newsletter-form').data('cookie-expire');
		let success = validationRules.emailValidate(email) || false;
		if (!success) {
			event.preventDefault();
		} else {
			const container = $(form).closest('.js-newsletter-form');
			this.toggleSubmitted(container);
			// Create cookie
			Cookies.set(cookieName, 'shown', { expires: cookieDate, sameSite: 'strict' });
		}
	}

	toggleSubmitted(container) {
		const before = $(container).find('.newsletter-before');
		const after = $(container).find('.newsletter-after');
		$(before).addClass('d-none');
		$(after).removeClass('d-none');
	}

	bindEvents() {
		let end = new Date(countdownEnd);
		let second = 1000;
		let minute = second * 60;
		let hour = minute * 60;
		let day = hour * 24;
		let timer;

		function showRemaining() {
			let countdown = $('#countdown-timer');
			let now = new Date();
			let distance = end - now;
			let days = Math.floor(distance / day);
			let hours = Math.floor((distance % day) / hour);
			let minutes = Math.floor((distance % hour) / minute);
			let seconds = Math.floor((distance % minute) / second);

			if (countdown.length) {
				if (distance < 0) {
					clearInterval(timer);
					//document.getElementById('countdown-timer').style.display = 'none';
					document.getElementById('countdown-timer').classList.add('d-none');
					return;
				} else {
					document.getElementById('countdown-timer').classList.remove('d-none');
					document.getElementById('countdown-timer').classList.add('bg-gray');
					document.getElementById('countdown-timer-container').classList.remove('d-none');
				}

				document.getElementById('countdown-timer-inner').innerHTML = `<div class="countdown-wrapper"><div class="countdown-box"><span class="counter-element days">${days}<p class="label">days</p></span><span class="counter-element hours">${hours}<p class="label">hrs</p></span><span class="counter-element minutes">${minutes}<p class="label">mins</p></span><span class="counter-element seconds">${seconds}<p class="label">secs</p></span></div></div>`;

				if (document.getElementById('countdown-cta')) {
					document.getElementById('countdown-cta').classList.remove('hide');
				}
				if (document.getElementById('countdown-button')) {
					document.getElementById('countdown-button').classList.remove('hide');

					if (window.history.length > 1) {
						document.getElementById('countdown-button').innerHTML = '<a onclick="history.go(-1);">back to previous page</a>';
					} else {
						document.getElementById('countdown-button').innerHTML = '<a href="/">back to Lung.org</a>';
					}
				}
			}
		}
		timer = setInterval(showRemaining, 1000);
	}
}

export default CountdownOverlay;